import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const UpcomingSessionCard = ({ 
  type, 
  title, 
  instructor, 
  instructorImage, 
  instructorImageAlt, 
  date, 
  time, 
  duration, 
  location,
  onManage,
  onCancel 
}) => {
  const getTypeConfig = () => {
    switch (type) {
      case 'class':
        return { icon: 'Users', color: 'var(--color-primary)', bg: 'bg-primary/10' };
      case 'training':
        return { icon: 'User', color: 'var(--color-accent)', bg: 'bg-accent/10' };
      case 'assessment':
        return { icon: 'ClipboardCheck', color: 'var(--color-success)', bg: 'bg-success/10' };
      default:
        return { icon: 'Calendar', color: 'var(--color-secondary)', bg: 'bg-secondary/10' };
    }
  };

  const config = getTypeConfig();

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm p-4 md:p-5">
      <div className="flex items-start gap-3 md:gap-4 mb-4">
        <div className={`flex items-center justify-center h-10 w-10 md:h-12 md:w-12 rounded-lg ${config?.bg} flex-shrink-0`}>
          <Icon name={config?.icon} size={20} color={config?.color} strokeWidth={2.5} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
            {title}
          </h4>
          <div className="flex items-center gap-2 mb-2">
            <Image 
              src={instructorImage} 
              alt={instructorImageAlt}
              className="h-6 w-6 rounded-full object-cover"
            />
            <span className="text-sm text-muted-foreground">{instructor}</span>
          </div>
        </div>
      </div>
      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
          <span>{date}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
          <span>{time} ({duration})</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-foreground">
          <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
          <span>{location}</span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onManage}
          className="flex-1 flex items-center justify-center gap-2 h-9 md:h-10 px-4 bg-primary text-primary-foreground rounded-lg font-medium text-sm transition-smooth hover-lift press-scale"
        >
          <Icon name="Settings" size={16} />
          <span>Manage</span>
        </button>
        <button
          onClick={onCancel}
          className="flex items-center justify-center h-9 md:h-10 w-9 md:w-10 bg-muted text-foreground rounded-lg transition-smooth hover:bg-error hover:text-error-foreground press-scale"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
    </div>
  );
};

export default UpcomingSessionCard;